<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Location' : 'New Location'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  ref="firstInput"
                  v-model="entity.name"
                  :error-messages="errors"
                  label="Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Type"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="entity.type"
                  :items="locationTypes"
                  item-text="value"
                  :error-messages="errors"
                  label="Type"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="4">
              <ValidationProvider
                name="Latitude"
                rules="between:-90,90"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="number"
                  v-model="entity.latitude"
                  label="Latitude"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="4">
              <ValidationProvider
                name="Longitude"
                rules="between:-180,180"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="number"
                  v-model="entity.longitude"
                  label="Longitude"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-if="edit"
                v-model="entity.isActive"
                label="Active"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';


export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  computed: {
    ...mapState(['locationsStore']),
    locationTypes() {
      return this.locationsStore ? this.locationsStore.locationTypes : null;
    },
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
  created() {
    this.$store.dispatch('locationsStore/loadLocationTypes');
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
  },
};
</script>

<style>
</style>
